import type React from 'react';

import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC<EmptyProps> = () => {
	useTrackPageView();

	return (
		<div className="container mb-6 space-y-8 md:mb-16 md:space-y-16">
			<PageHeading />
			<PageBody />
		</div>
	);
};
